import { render, staticRenderFns } from "./casestudies.vue?vue&type=template&id=67dd51c8&scoped=true&"
var script = {}
import style0 from "./casestudies.vue?vue&type=style&index=0&id=67dd51c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd51c8",
  null
  
)

export default component.exports